export const tags = [
    'TransferSyntaxUID',
    'AvailableTransferSyntaxUID',
];
